import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'gatsby-plugin-intl'
import { EXCHANGE_MAP_TYPES } from './offerMapUtils'

const TYPE_LABELS = {
  [EXCHANGE_MAP_TYPES.EXPORT]: 'offers.mapRoundTripExport',
  [EXCHANGE_MAP_TYPES.GENERAL]: 'offers.mapRoundTripGeneral'
}

const RoundTripRefreshNotice = ({
  failedExchangeTypes = [],
  refreshError = false,
  updatedAt,
  onRetry,
  refreshing = false
}) => {
  const intl = useIntl()
  if (!refreshError && failedExchangeTypes.length === 0) return null

  const exchanges = failedExchangeTypes
    .map(type => intl.formatMessage({ id: TYPE_LABELS[type] }))
    .join(', ')

  return (
    <Notice role='status'>
      <span>
        {refreshError
          ? intl.formatMessage({
              id: 'offers.mapRoundTripRefreshError',
              defaultMessage:
                'Could not refresh return offers. Showing the last available results.'
            })
          : intl.formatMessage(
              {
                id: 'offers.mapRoundTripPartialError',
                defaultMessage:
                  'Some offers could not be refreshed ({exchanges}). Results may be incomplete or out of date.'
              },
              { exchanges }
            )}
      </span>
      {updatedAt > 0 && (
        <span>
          {intl.formatMessage(
            {
              id: 'offers.mapLastUpdated',
              defaultMessage: 'Last updated: {time}'
            },
            {
              time: intl.formatDate(updatedAt, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              })
            }
          )}
        </span>
      )}
      {onRetry && (
        <button type='button' onClick={onRetry} disabled={refreshing}>
          {intl.formatMessage({
            id: 'offers.mapRetry',
            defaultMessage: 'Try again'
          })}
        </button>
      )}
    </Notice>
  )
}

const Notice = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.75rem;
  font-size: 0.8rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.ghost.hex()};
`

export default RoundTripRefreshNotice
